export enum eOrderLinkType {
  acquisition_resale = 'acquisition_resale',
  search_acquisition = 'search_acquisition',
}
